<div class="complaints-wrapper" [class.arabic-content]="textDirection === 'rtl'">
  <section class="cbk-section">
    <div class="inner">
      <h1 class="page-title" translate>CUSTOMER_COMPLAINTS.MAIN_TITLE</h1>

      <img src="assets/images/c-banner.svg" alt="" class="cbk-banner" />

      <p class="cbk-subtitle" translate>CUSTOMER_COMPLAINTS.COMPLAINT_REASON</p>

      <div class="steps-grid">
        @for (step of cbkSteps; track step; let i = $index) {
          <div class="step-card">
            <span class="step-num">{{ i + 1 }}</span>
            <p>{{ step | translate }}</p>
          </div>
        }
      </div>
    </div>
  </section>

  <section class="taly-section">
    <div class="inner">
      <h2 class="section-title" translate>CUSTOMER_COMPLAINTS.CUSTOMNER_COMPLAINTS_UNIT</h2>
      <p class="section-desc" translate>CUSTOMER_COMPLAINTS.CUSTOMER_COMPLAINTS_DESCRIPTION</p>
      <p class="methods-intro" translate>CUSTOMER_COMPLAINTS.COMPLAINTS_METHODS</p>
      <ol class="methods-list">
        @for (item of methodItems; track item) {
          <li>{{ item | translate }}</li>
        }
      </ol>
    </div>
  </section>

  <section class="remarks-section">
    <div class="inner">
      <h2 class="section-title" translate>CUSTOMER_COMPLAINTS.REMARKS</h2>
      <ol class="remarks-list">
        @for (remark of remarkItems; track remark) {
          <li>{{ remark | translate }}</li>
        }
      </ol>
      <a
        (click)="downloadPdf()"
        (keyup.enter)="downloadPdf()"
        (keyup.space)="downloadPdf()"
        role="button"
        tabindex="0"
        style="cursor: pointer"
        class="download-link"
        translate
        >BUTTON.DOWNLOAD_COMPLAINT_FORM</a
      >
    </div>
  </section>
  <section class="activity-section">
    <div class="inner">
      <h2 class="section-title" translate>CUSTOMER_COMPLAINTS.REMARKS_9</h2>
      <p class="activity-text">{{ 'CUSTOMER_COMPLAINTS.REMARKS_10' | translate }}</p>
      <!-- <p class="protection-unit" translate>CUSTOMER_COMPLAINTS.PROTECTION_UNIT</p> -->
      <p class="protection-unit">
        <span translate>CUSTOMER_COMPLAINTS.PROTECTION_UNIT</span>
        <span dir="ltr">
          {{ 'CUSTOMER_COMPLAINTS.PROTECTION_UNIT_NUMBER' | translate }}
        </span>
      </p>
      <p class="protection-unit email" translate>CUSTOMER_COMPLAINTS.EMAIL_ADDRESS</p>
      <p class="activity-text licence" translate>CUSTOMER_COMPLAINTS.REMARKS_11</p>
    </div>
  </section>

  <section class="faq-section">
    <div class="inner">
      <div class="faq-layout">
        <div class="faq-left">
          <h2 class="section-title desktop" translate>HOME_PAGE.FAQ_TITLE</h2>
          <h2 class="section-title mobile" translate>FOOTER.FAQ</h2>
          <a routerLink="/faq-shopper" class="see-all-btn desktop" translate>HOME_PAGE.ALL_FAQ</a>
          <a routerLink="/faq-shopper" class="see-all-btn mobile" translate
            >HOME_PAGE.ALL_FAQ_MOB</a
          >
        </div>
        <!-- <div class="faq-right">
          <taly-custom-accordion [items]="faqItems" [textDirection]="textDirection" />
        </div> -->
      </div>
    </div>
  </section>

  <section class="security-section">
    <div class="inner">
      <div class="security-grid">
        @for (tip of securityTips; track tip.icon) {
          <div class="security-card">
            <img [src]="tip.icon" alt="" />
            <p>{{ tip.key | translate }}</p>
          </div>
        }
      </div>
    </div>
  </section>
</div>
